import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRouteGuard({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="p-8 text-center">
        Verifying Admin access...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (user.role === "admin" && user.active !== false) {
    return children;
  }

  if (
    user.role === "staff" &&
    user.department === "it_support"
  ) {
    return <Navigate to="/it" replace />;
  }

  if (user.role === "vendor") {
    return <Navigate to="/vendor/dashboard" replace />;
  }

  return <Navigate to="/" replace />;
}
